import request from "./request";
import { errorProcessor, getQueryStringParameter } from "./utils";

const BASE_URL = process.env.REACT_APP_BASE_URL;


export function getPackages(payload) {
  const options = {
    baseUrl: BASE_URL,
    url: "/customers" + getQueryStringParameter(payload),
    method: "GET",
  };
  return request
    .make(options)
    .then((res) => res)
    .catch(errorProcessor);
}

export function makePayment(payload) {
  const options = {
    baseUrl: BASE_URL,
    url: "transactionlogs",
    method: "POST",
    data: payload,
  };
  return request
    .make(options)
    .then((res) => res)
    .catch(errorProcessor);
}
